import axios from "axios";

let apiVersion = process.env.REACT_APP_API_BASE_URL;
const publicAxios = axios.create({
    baseURL: apiVersion,
    headers: { 'Content-Type': 'application/json' }
  })

export default publicAxios;
